<template>
  <div class="modal-overlay" v-if="show && place">
    <!-- ====== ДЕТАЛІ ДЛЯ ЗОЗ ====== -->
    <div class="modal-content" v-if="place.email || place.info_phone_number">
      <h2>Деталі закладу</h2>

      <p v-if="place.name">
        <strong>Назва:</strong> <span>{{ place.name }}</span>
      </p>

      <p v-if="place.address">
        <strong>Адреса:</strong> <span>{{ place.address }}</span>
      </p>

      <p v-if="place.info_phone_number">
        <strong>Телефони:</strong>
        <span>{{ place.info_phone_number }}</span>
      </p>

      <p v-if="displayEmail">
        <strong>E-mail: </strong>
        <span><a :href="`mailto:${displayEmail}`">{{ displayEmail }}</a></span>
      </p>

      <div class="flex-info">
        <div class="meds" v-if="place.buprenorphin_available !== undefined || place.methadon_available !== undefined">
          <p><strong>Наявність препаратів:</strong></p>
          <p v-if="place.buprenorphin_available !== undefined">
            Бупренорфін:
            <span :class="place.buprenorphin_available ? 'yes' : 'no'">
              {{ place.buprenorphin_available ? 'Так' : 'Ні' }}
            </span>
          </p>
          <p v-if="place.methadon_available !== undefined">
            Метадон:
            <span :class="place.methadon_available ? 'yes' : 'no'">
              {{ place.methadon_available ? 'Так' : 'Ні' }}
            </span>
          </p>
        </div>

        <div class="schedule" v-if="place.schedule_of_zpt">
          <p><strong>Графік роботи кабінету ЗПТ:</strong></p>
          <ScheduleView :schedule="place.schedule_of_zpt" />
        </div>
      </div>

      <button @click="closeModal">Закрити</button>
    </div>

    <!-- ====== ДЕТАЛІ ДЛЯ ПЗШ ====== -->
    <div class="modal-content" v-else>
      <h2>Деталі закладу</h2>
      <!-- <pre>{{ place }}</pre>-->

      <p v-if="place.organisation?.title || place.title">
        <strong>Назва:</strong> <span>{{ place.organisation?.title || place.title }}</span>
      </p>

      <p v-if="place.address">
        <strong>Адреса:</strong> <span>{{ place.address }}</span>
      </p>

      <p v-if="place.coordinator?.phone_number || place.info_phone_number">
        <strong>Телефон:</strong> <span>{{ place.coordinator?.phone_number || place.info_phone_number }}</span>
      </p>

      <button @click="closeModal">Закрити</button>
    </div>

  </div>
</template>


<script>
import ScheduleView from "@/components/ScheduleView.vue";

export default {
  components: { ScheduleView },
  props: {
    show: Boolean,
    place: {
      type: Object,
      default: () => null
    }
  },
  computed: {
    displayEmail() {
      return this.place?.hosp_email || this.place?.email || '';
    }
  },
  mounted() {
  },
  methods: {
    closeModal() {
      this.$emit("close");
    }
  }
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.modal-content {
  background: white;
  padding: 24px;
  border-radius: 16px;
  max-width: 640px;
  width: 100%;
  text-align: left;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  font-size: 16px;
  color: var(--col-mainblue);
}

h2 {
  text-align: center;
  color: var(--col-mainblue);
  margin-bottom: 24px;
}

.flex-info {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 24px;
  margin-top: 16px;
}

.meds,
.schedule {
  flex: 1;
  min-width: 240px;
}

.yes {
  color: var(--col-text-green);
  font-weight: 600;
}

.no {
  color: var(--col-text-orange);
  font-weight: 600;
}

button {
  display: block;
  margin: 32px auto 0;
  background-color: var(--col-mainblue);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 16px;
  cursor: pointer;
}
</style>
